if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }

$(function() {
  var FadeTransition, SlideTransition, SlideBackTransition, lastClickedEl;

  FadeTransition = Barba.BaseTransition.extend({
    start: function() {
      /**
       * This function is automatically called as soon the Transition starts
       * this.newContainerLoading is a Promise for the loading of the new container
       * (Barba.js also comes with an handy Promise polyfill!)
       */
      // As soon the loading is finished and the old page is faded out, let's fade the new page
      Promise
        .all([this.newContainerLoading, this.fadeOut()])
        .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
      /**
       * this.oldContainer is the HTMLElement of the old Container
       */

      fadeOutAnimation = new TimelineMax();

      fadeOutAnimation
        .set($(".navbar"), {className:"-=navbar--subpage"})
        .set($("body"), {className:"-=subpage"})
      
      return $(this.oldContainer).animate({ opacity: 0}, 500).promise();
    },

    fadeIn: function() {
      /**
       * this.newContainer is the HTMLElement of the new Container
       * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
       * Please note, newContainer is available just after newContainerLoading is resolved!
       */

      var _this = this;
      var $el = $(this.newContainer);

      $(this.oldContainer).hide();

      $(window).scrollTop(0);

      transitionAnimation = new TimelineMax();
        
      transitionAnimation
        .set($el,{opacity:0, visibility:"visible"})
        .to($el, 0.5,{opacity:1, ease:Power2.easeOut})
        // .from($(".navbar, .scroll-navbar"),1,{y:-96, ease:Expo.easeInOut}, 0.5)
        .staggerFrom($("[data-transition-slide-up]"),1.6,{opacity:0, y:100, ease:Power2.easeOut}, 0.3, 0.5)
        .staggerFrom($("[data-transition-stagger]"),0.9,{opacity:0, y:100, ease:Expo.easeOut}, 0.09, 0.5)
        .staggerFrom($("[data-transition-stagger-slow]"),1.5,{opacity:0, y:100, ease:Expo.easeOut}, 0.1, 0.5);

      _this.done();
    }
  });

  OfferTransition = Barba.BaseTransition.extend({
    start: function() {
      /**
       * This function is automatically called as soon the Transition starts
       * this.newContainerLoading is a Promise for the loading of the new container
       * (Barba.js also comes with an handy Promise polyfill!)
       */
      // As soon the loading is finished and the old page is faded out, let's fade the new page
      Promise
        .all([this.newContainerLoading, this.fadeOut()])
        .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
      /**
       * this.oldContainer is the HTMLElement of the old Container
       */

      fadeOutAnimation = new TimelineMax();

      fadeOutAnimation
        .set($(".navbar"), {className:"+=navbar--subpage"})
        .staggerTo($("[data-offer-transition-hide]"),0.4,{opacity:0, scale: 0.98, y:-90, ease:Power3.easeIn}, 0.01)
        .to($("[data-offer-transition-scale]"),0.8,{scaleY: 0, transformOrigin: '0 0',  ease:Power3.easeIn}, "-=0.4")
        .staggerTo($(".offers__item"),0.7,{y:-300, ease:Power3.easeIn}, 0.02, "-=0.9")
      
      return $(this.oldContainer).animate({ opacity: 0}, 700).promise();
    },

    fadeIn: function() {
      /**
       * this.newContainer is the HTMLElement of the new Container
       * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
       * Please note, newContainer is available just after newContainerLoading is resolved!
       */

      var _this = this;
      var $el = $(this.newContainer);

      $(this.oldContainer).hide();

      $(window).scrollTop(0);

      transitionAnimation = new TimelineMax();
        
      transitionAnimation
        // .set($el,{opacity:0, visibility:"visible"})
        // .to($el, 0.5,{opacity:1, ease:Power2.easeOut})
        .set($(".navbar"), {className:"+=navbar--subpage"})
        .set($("body"), {className:"+=subpage"})
        .staggerFrom($("[data-transition-stagger]"),0.5,{opacity:0, y:100, ease:Expo.easeOut}, 0.09, "-=0.7")

      _this.done();
    }
  });

  SeminarTransition = Barba.BaseTransition.extend({
    start: function() {
      /**
       * This function is automatically called as soon the Transition starts
       * this.newContainerLoading is a Promise for the loading of the new container
       * (Barba.js also comes with an handy Promise polyfill!)
       */
      // As soon the loading is finished and the old page is faded out, let's fade the new page
      Promise
        .all([this.newContainerLoading, this.fadeOut()])
        .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
      /**
       * this.oldContainer is the HTMLElement of the old Container
       */

      fadeOutAnimation = new TimelineMax();

      fadeOutAnimation
        .set($(".navbar"), {className:"+=navbar--subpage"})
        .staggerTo($("[data-seminar-transition-hide]"),0.4,{opacity:0, scale: 0.98, y:-90, ease:Power3.easeIn}, 0.01)
        .staggerTo($(".seminars__item"),0.7,{y:-300, ease:Power3.easeIn}, 0.02, "-=0.4")
      
      return $(this.oldContainer).animate({ opacity: 0}, 800).promise();
    },

    fadeIn: function() {
      /**
       * this.newContainer is the HTMLElement of the new Container
       * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
       * Please note, newContainer is available just after newContainerLoading is resolved!
       */

      var _this = this;
      var $el = $(this.newContainer);

      $(this.oldContainer).hide();

      $(window).scrollTop(0);

      transitionAnimation = new TimelineMax();
        
      transitionAnimation
        // .set($el,{opacity:0, visibility:"visible"})
        // .to($el, 0.5,{opacity:1, ease:Power2.easeOut})
        .set($(".navbar"), {className:"+=navbar--subpage"})
        .set($("body"), {className:"+=subpage"})
        .staggerFrom($("[data-transition-stagger]"),0.5,{opacity:0, y:100, ease:Expo.easeOut}, 0.09, "-=0.7")

      _this.done();
    }
  });

  BackTransition = Barba.BaseTransition.extend({
    start: function() {
      /**
       * This function is automatically called as soon the Transition starts
       * this.newContainerLoading is a Promise for the loading of the new container
       * (Barba.js also comes with an handy Promise polyfill!)
       */
      // As soon the loading is finished and the old page is faded out, let's fade the new page
      Promise
        .all([this.newContainerLoading, this.fadeOut()])
        .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {
      /**
       * this.oldContainer is the HTMLElement of the old Container
       */

      fadeOutAnimation = new TimelineMax();

      fadeOutAnimation
        .staggerTo($("[data-transition-stagger]"),0.6,{y:150, ease:Power3.easeIn}, -0.05)
        .set($(".navbar"), {className:"-=navbar--subpage"})
        .set($("body"), {className:"-=subpage"})
      
      return $(this.oldContainer).animate({ opacity: 0}, 600).promise();
    },

    fadeIn: function() {
      /**
       * this.newContainer is the HTMLElement of the new Container
       * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
       * Please note, newContainer is available just after newContainerLoading is resolved!
       */

      var _this = this;
      var $el = $(this.newContainer);

      $(this.oldContainer).hide();

      $(window).scrollTop(0);

      transitionAnimation = new TimelineMax();
        
      transitionAnimation
        // .set($el,{opacity:0, visibility:"visible"})
        // .to($el, 0.5,{opacity:1, ease:Power2.easeOut})
        .staggerFrom($("[data-transition-stagger]"),0.5,{opacity:0, y:100, ease:Expo.easeOut}, 0.09, "-=0.7")

      _this.done();
    }
  });

  lastClickedEl = null;
  Barba.Dispatcher.on('linkClicked', function(el) {
    return lastClickedEl = el;
  });
  Barba.Pjax.getTransition = function() {
    if ($(lastClickedEl).hasClass('offers__item__inner')) {
      return OfferTransition;
    } else if($(lastClickedEl).hasClass('seminars__item__inner')) {
      return SeminarTransition;
    } else if($(lastClickedEl).hasClass('back-link')) {
      return BackTransition;
    } else {
      return FadeTransition;
    }
  };

  classes = ["color-1", "color-2", "color-3", "color-4"];
  randomClass = classes[Math.floor(Math.random() * classes.length)];
  $(".navbar").addClass(randomClass)
  console.log(randomClass)

  Barba.Dispatcher.on('newPageReady', function(current, prev, container) { history.scrollRestoration = 'manual'; });

  //Edit crauch - Quick and dirty damit slider usw. wieder neu intialisiert werden auch wenn die Seite schonmal aufgerufen wurde
  Barba.Pjax.cacheEnabled = false;
  return Barba.Pjax.start();
});